<script setup lang="ts">
import { PanelsTopLeft } from 'lucide-vue-next'
import { DropdownMenuItem } from '../../ui/dropdown-menu'
import { Switch } from '../../ui/switch'
import type { Elemental } from '~~/src/types/elemental'
import { setElementalTemplate } from '~~/src/api/elementals'
import { useTemplateElemental } from '~~/src/composables/mutations/elemetal/useTemplateElemental'

const { elemental } = defineProps<{
  elemental: Elemental
}>()

const { invalidateTemplateQueries } = useTemplateElemental()

defineOptions({
  name: 'ElementalTemplate',
})

const isTemplate = ref(elemental.settings?.isTemplate ?? false)

const toggleIsTemplate = async () => {
  await setElementalTemplate(elemental.id, isTemplate.value)
  await invalidateTemplateQueries(elemental)
}
</script>

<template>
  <DropdownMenuItem @select.prevent="">
    <PanelsTopLeft />
    Template
    <Switch v-model:checked="isTemplate" size="xs" class="ml-auto" @update:checked="toggleIsTemplate" />
  </DropdownMenuItem>
</template>
